// errors/NotSupportedError.ts
import { BaseError } from "@adornis/validation/errors/BaseError.js";
var NotSupportedError = class extends BaseError {
  static {
    this._class = "NotSupportedError";
  }
  constructor(name, extensions = {}) {
    extensions.name = name;
    if (!extensions.translationKey)
      extensions.translationKey = "baseql_notSupported";
    super(
      `Member "${name}" is not supported on SimpleCollections.
    You can use "getRawCollection" to access the unprotected monogdb collection but you have to handle publishfilter and permissions yourself.`,
      extensions
    );
  }
  static createFromDetails(message, extensions) {
    return new this(extensions.name, extensions);
  }
};
export {
  NotSupportedError
};
